'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getBrowserSpecs = exports.getBrowserSpecs = function getBrowserSpecs() {
  if (typeof navigator === 'undefined') {
    return { name: '', version: '' };
  }
  var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return { name: M[0], version: M[1] };
};

var resolveImage = exports.resolveImage = function resolveImage(svgImage, pngImage) {
  var browser = getBrowserSpecs();
  if (browser.name === 'IE' && browser.version === '9') {
    return pngImage;
  }
  return svgImage;
};